import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M480-540 311-371q-12 12-28 11t-28-12q-12-12-12-29t12-28l197-196q11-12 28-12t28 12l198 197q12 12 12 28t-12 28q-12 12-29 12t-28-12L480-540Z"/>',
  f: '<path d="M480-540 311-371q-12 12-28 11t-28-12q-12-12-12-29t12-28l197-196q11-12 28-12t28 12l198 197q12 12 12 28t-12 28q-12 12-29 12t-28-12L480-540Z"/>',
};

export default data;
